import React from 'react';

const ConfirmationImage = props => (
  <svg
    width="328"
    height="209"
    viewBox="0 0 328 209"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="Confirmation-(2)">
        <rect
          id="Rectangle-path"
          fill="#FFF"
          fillRule="nonzero"
          x="28.8"
          y="15.2"
          width="270.1"
          height="168.6"
        />
        <rect
          id="Rectangle-path"
          fill="#FFF"
          fillRule="nonzero"
          x="18.9"
          y="185"
          width="1"
          height="3.3"
        />
        <g id="Group">
          <g id="Shape">
            <g transform="translate(2 37)">
              <path
                d="M202.6,117.5 L199.7,118 L198.4,119.1 L188.9,125.2 C188.9,125.2 187.3,125.4 187.1,126.1 C186.9,126.8 175.3,130 175.3,130 L173,131.2 L151.4,113.2 L162.4,89.2 L177.1,86.5 L202.6,117.5 Z"
                fill="#C59363"
                fillRule="nonzero"
              />
              <path
                d="M123.2,86.6 C126.7,87.1 129.2,90.8 128.7,94.9 L127.6,104 C127.1,108.1 123.9,111 120.6,110.5 C117.2,110 114.8,106.2 115.2,102.1 L116.1,93.1 C116.6,89 119.8,86.1 123.2,86.6 Z"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M123.2,86.6 C126.7,87.1 129.2,90.8 128.7,94.9 L127.6,104 C127.1,108.1 123.9,110.9 120.6,110.3 C117.2,109.7 114.8,105.9 115.2,101.8 L116.1,93.1 C116.6,89 119.8,86.1 123.2,86.6 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M212.8,100.6 L172.1,65.4 L180.5,68.7 C184.3,70.2 188.6,68.3 190.1,64.4 L190.5,63.3 C191.9,59.4 190,55.1 186.2,53.6 C186.2,53.6 165.8,45.7 163.4,44.7 C161.7,44.1 160.2,43.7 158.5,44.3 L134.1,53.1 C133.8,53.2 133.5,53.3 133.3,53.5 L118,46.9 L100,88 L126.3,99.4 C125.6,102.1 126.6,105.2 129,107 L165.2,135.5 C168.4,138 173.1,137.5 175.6,134.3 C176.5,133.2 177,131.8 177.1,130.4 L178.3,131.4 C181.5,133.9 186.2,133.4 188.7,130.2 C190.3,128.2 190.6,125.6 189.8,123.3 L190.4,123.8 C193.6,126.3 198.4,125.8 200.9,122.6 L201.3,122.1 C203.2,119.7 203.4,116.4 202,113.9 L202,113.9 C205.2,116.4 210,115.8 212.5,112.6 L213.5,111.3 C216.3,108.1 215.9,103.3 212.8,100.6 Z"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M163.4,64.4 L211.3,106 C212.9,107.4 213.8,109.3 213.9,111.2 C216.3,108 215.8,103.2 212.8,100.6 L170,63.9 C168.8,64.1 163.4,64.4 163.4,64.4 Z"
                fill="#CBE8E3"
                fillRule="nonzero"
              />
              <path
                d="M116.4,52.2 L131.7,58.8 C132,58.7 132.2,58.5 132.5,58.4 L156.9,49.6 C158.6,49 160.1,49.4 161.8,50 C164.3,50.9 184.6,58.9 184.6,58.9 C187.4,60 189.3,62.7 189.4,65.6 C189.7,65.2 189.9,64.7 190.1,64.3 L190.5,63.2 C191.9,59.3 190,55 186.2,53.5 C186.2,53.5 165.8,45.6 163.4,44.6 C161.7,44 160.2,43.6 158.5,44.2 L134.1,53 C133.8,53.1 133.5,53.2 133.3,53.4 L118,46.8 L100.1,88 L100.8,88.3 L116.4,52.2 Z"
                fill="#CBE8E3"
                fillRule="nonzero"
              />
              <path
                d="M212.8,100.6 L172.1,65.4 L180.5,68.7 C184.3,70.2 188.6,68.3 190.1,64.4 L190.5,63.3 C191.9,59.4 190,55.1 186.2,53.6 C186.2,53.6 165.8,45.7 163.4,44.7 C161.7,44.1 160.2,43.7 158.5,44.3 L134.1,53.1 C133.8,53.2 133.5,53.3 133.3,53.5 L118,46.9 L100,88 L126.3,99.4 C125.6,102.1 126.6,105.2 129,107 L165.2,135.5 C168.4,138 173.1,137.5 175.6,134.3 C176.5,133.2 177,131.8 177.1,130.4 L178.3,131.4 C181.5,133.9 186.2,133.4 188.7,130.2 C190.3,128.2 190.6,125.6 189.8,123.3 L190.4,123.8 C193.6,126.3 198.4,125.8 200.9,122.6 L201.3,122.1 C203.2,119.7 203.4,116.4 202,113.9 L202,113.9 C205.2,116.4 210,115.8 212.5,112.6 L213.5,111.3 C216.3,108.1 215.9,103.3 212.8,100.6 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polygon
                fill="#FFF"
                fillRule="nonzero"
                points="9.3 52.2 108.4 92.9 127.2 49.5 105.4 40"
              />
              <polygon
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="9.3 52.2 108.4 92.9 127.2 49.5 28.1 8.8"
              />
              <polygon
                fill="#4DBED8"
                fillRule="nonzero"
                points="0 56.2 99.1 96.9 123.2 41.3 24.1 0.6"
              />
              <polygon
                fill="#65C9DB"
                fillRule="nonzero"
                points="116.2 43.5 24.1 6.3 25.9 2 123.1 41.3 98.9 96.9 93.9 94.8"
              />
              <polygon
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="0 56.2 99.1 96.9 123.2 41.3 24.1 0.6"
              />
              <path
                d="M211.5,99.5 L319.4,50.3 L301.6,9.2 L205,53.5 C204.7,53.3 204.4,53.2 204.1,53.1 L179.7,44.3 C178,43.7 176.1,43.9 174.7,44.8 C174.5,44.9 174.2,44.9 174,45 L152.3,53.5 C150,54.4 148.9,56.2 147.8,58.5 C147,60.3 142.2,71.5 142.2,71.5 C140.6,75.3 142.2,79.6 145.8,81.2 C149.4,82.7 153.7,80.9 155.3,77.1 L159.2,68.1 L170,63.9 C170.9,64.9 211.5,99.5 211.5,99.5 Z"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M147.9,65.6 C149,63.3 150.1,61.5 152.4,60.6 L174.1,52 C174.3,51.9 174.6,51.8 174.8,51.8 C176.3,50.9 178.1,50.6 179.8,51.3 L204.2,60.1 C204.5,60.2 204.8,60.3 205.1,60.5 L301.7,16.2 L317,51.4 L319.5,50.3 L301.7,9.2 L205.1,53.5 C204.8,53.3 204.5,53.2 204.2,53.1 L179.8,44.3 C178.1,43.7 176.2,43.9 174.8,44.8 C174.6,44.9 174.3,44.9 174.1,45 L152.4,53.5 C150.1,54.4 149,56.2 147.9,58.5 C147.1,60.3 142.3,71.5 142.3,71.5 C141.4,73.7 141.5,76.1 142.5,78 C143.4,75.9 147.2,67.1 147.9,65.6 Z"
                fill="#CBE8E3"
                fillRule="nonzero"
              />
              <path
                d="M211.5,99.5 L319.4,50.3 L301.6,9.2 L205,53.5 C204.7,53.3 204.4,53.2 204.1,53.1 L179.7,44.3 C178,43.7 176.1,43.9 174.7,44.8 C174.5,44.9 174.2,44.9 174,45 L152.3,53.5 C150,54.4 148.9,56.2 147.8,58.5 C147,60.3 142.2,71.5 142.2,71.5 C140.6,75.3 142.2,79.6 145.8,81.2 C149.4,82.7 153.7,80.9 155.3,77.1 L159.2,68.1 L170,63.9 C170.4,64.5 211.5,99.5 211.5,99.5 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M202.2,113.9 L172.2,88.6"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M189.9,123.3 L165.4,102.5"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M177.2,130.5 L161.2,116.8"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M135.4,98.3 C137,101.1 136.1,104.6 133.4,106.3 L125.5,111 C122.7,112.6 119.2,111.7 117.5,109 L116.9,108 C115.3,105.2 116.2,101.7 118.9,100 L126.8,95.3 C129.6,93.7 133.1,94.6 134.8,97.3 L135.4,98.3 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M135.4,98.3 C137,101.1 136.1,104.6 133.4,106.3 L125.5,111 C122.7,112.6 119.2,111.7 117.5,109 L117,108.2 C115.4,105.4 116.3,101.9 119,100.2 L126.9,95.5 C129.7,93.9 133.2,94.8 134.9,97.5 L135.4,98.3 Z"
                stroke="#636464"
                strokeWidth="2.5"
                fill="#5FC3B5"
                fillRule="nonzero"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M147.2,107.2 C148.8,110 147.9,113.5 145.2,115.2 L135.5,121 C132.7,122.6 129.2,121.7 127.5,119 L126.5,117.4 C124.9,114.6 125.8,111.1 128.5,109.4 L138.2,103.6 C141,102 144.5,102.9 146.2,105.6 L147.2,107.2 Z"
                stroke="#636464"
                strokeWidth="2.5"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M147.2,107.2 C148.8,110 147.9,113.5 145.2,115.2 L135.5,121 C132.7,122.6 129.2,121.7 127.5,119 L126.5,117.4 C124.9,114.6 125.8,111.1 128.5,109.4 L138.2,103.6 C141,102 144.5,102.9 146.2,105.6 L147.2,107.2 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M157.1,116 C158.7,118.8 157.8,122.3 155.1,124 L145.2,129.9 C142.4,131.5 138.9,130.6 137.2,127.9 L136.8,127.1 C135.2,124.3 136.1,120.8 138.8,119.1 L148.7,113.2 C151.5,111.6 155,112.5 156.7,115.2 L157.1,116 Z"
                stroke="#636464"
                strokeWidth="2.5"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M157.1,116 C158.7,118.8 157.8,122.3 155.1,124 L145.2,129.9 C142.4,131.5 138.9,130.6 137.2,127.9 L136.8,127.1 C135.2,124.3 136.1,120.8 138.8,119.1 L148.7,113.2 C151.5,111.6 155,112.5 156.7,115.2 L157.1,116 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M162.4,125.5 C163.9,128 162.8,131.3 160.1,133 L156.9,134.9 C154.1,136.5 150.7,135.8 149.2,133.4 C147.7,130.9 148.8,127.6 151.5,125.9 L154.7,124 C157.6,122.4 160.9,123.1 162.4,125.5 Z"
                fill="#5FC3B5"
                fillRule="nonzero"
              />
              <path
                d="M162.4,125.5 C163.9,128 162.8,131.3 160.1,133 L156.9,134.9 C154.1,136.5 150.7,135.8 149.2,133.4 C147.7,130.9 148.8,127.6 151.5,125.9 L154.7,124 C157.6,122.4 160.9,123.1 162.4,125.5 Z"
                stroke="#636464"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g
              stroke="#8B8A8A"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M31.9,0.9 L31.9,21.3" transform="translate(133 37)" />
              <path d="M12.8,12 L20.6,22.8" transform="translate(133 37)" />
              <path d="M51.1,11.7 L43.9,23" transform="translate(133 37)" />
              <path d="M0.7,24.3 L9.4,29.2" transform="translate(133 37)" />
              <path d="M62.4,24.5 L53.6,29" transform="translate(133 37)" />
            </g>
          </g>
          <rect
            id="Rectangle-path"
            x="30.9"
            y="17.5"
            width="265.9"
            height="171.5"
          />
          <circle
            id="Oval"
            fill="#FFF"
            fillRule="nonzero"
            cx="164.6"
            cy="9.2"
            r="2.9"
          />
          <path
            d="M189.7,188.3 L189.7,188.8 C189.7,193.7 185.8,197.6 180.9,197.6 L147.3,197.6 C142.4,197.6 138.5,193.7 138.5,188.8 L138.5,188.3 L6.5,188.3 L6.5,200.9 C6.5,204.9 9.8,208.2 13.8,208.2 L314.3,208.2 C318.3,208.2 321.6,204.9 321.6,200.9 L321.6,188.3 L189.7,188.3 L189.7,188.3 Z"
            id="Shape"
            fill="#4DBED8"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle-path"
            x="31.2"
            y="188.3"
            width="265.6"
            height="1"
          />
          <rect id="Rectangle" fill="#FFF" y="47" width="19" height="60" />
          <rect
            id="Rectangle-Copy"
            fill="#FFF"
            x="309"
            y="47"
            width="19"
            height="60"
          />
          <path
            d="M31.2,183.8 L31.2,18 L296.8,18 L296.8,183.8 L309,183.8 L309,11 C309,5.4 304.4,0.8 298.8,0.8 L29.2,0.8 C23.6,0.8 19,5.4 19,11 L19,183.8 L31.2,183.8 Z"
            id="Shape"
            fill="#4DBED8"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ConfirmationImage;
